<section class="content">
    <div class="container-fluid">
         <!-- Dashboard Header -->
        <div class="card-header text-center">
            <h4 class="font-weight-bold text-dark">DASHBOARD</h4>
        </div>
         <!-- Dashboard Boxes -->
        <div class="row">
             <!-- Request Course Box -->
            <div class="col-lg-6 col-6">
                <div class="small-box bg-info" style="height: 95px;">
                    <div class="inner">
                        <h3 data-toggle="modal" data-target="#requestCourseModal" style="cursor: pointer">COURSE</h3>
                    </div>
                    <div class="icon">
                        <i class="fas fa-edit"></i>
                    </div>
                    <a data-toggle="modal" data-target="#requestCourseModal" style="cursor: pointer;margin-top: 20px;font-weight: bold;" class="small-box-footer">Request <i class="fas fa-arrow-circle-right"></i></a>
                </div>
            </div>
            <!-- Request Group Course Box -->
            <div class="col-lg-6 col-6">
                <div class="small-box" style="background-color: #C71585;height: 95px;">
                    <div class="inner">
                        <h3 data-toggle="modal" data-target="#requestGroupCourseModal"
                            style="cursor: pointer;text-align: center;color:white">GROUP COURSE</h3>
                    </div>
                    <div class="icon">
                        <i class="fas fa-clipboard"></i>
                    </div>
                    <a data-toggle="modal" data-target="#requestGroupCourseModal" style="cursor: pointer;margin-top: 20px;font-weight: bold;"
                        class="small-box-footer">Request<i class="fas fa-arrow-circle-right"></i></a>
                </div>
            </div>
             <!-- Number of New Courses Box -->
            <div class="col-lg-4 col-6">
                <div class="small-box" style="height: 95px;background-color: #483D8B">
                    <div class="inner">
                        <h3 style="color:white;text-align: center;font-size: large;">{{totalCourses}}</h3>
                        <p style="text-align: center;color:white;font-weight: bold;">No. of Course(s)</p>
                    </div>
                    <div class="icon">
                        <i class="fas fa-bell"></i>
                    </div>
                </div>
            </div>
            <!-- Number of Courses Enrolled Box -->
            <div class="col-lg-4 col-6">
                <div class="small-box bg-success" style="height: 95px;">
                    <div class="inner">
                        <h3 style="text-align: center;font-size: large;">{{enrolledCourses}}</h3>
                        <p style="text-align: center;font-weight: bold;">No. of Course(s) Enrolled</p>
                    </div>
                    <div class="icon">
                        <i class="fas fa-lock"></i>
                    </div>
                </div>
            </div>

            <div class="col-lg-4 col-sm-10">
                <div class="small-box " style="background-color: #9fa148;height: 95px;">
                    <div class="inner">
                        <h3 style="text-align: center;font-size: large;">{{pastcourseslength}}</h3>

                        <p style="text-align: center;font-weight: bold;">No. of Completed Course(s)</p>

                    </div>
                    <div class="icon">
                        <i class="fa fa-check-circle" aria-hidden="true"></i>
                    </div>
                </div>
            </div>
        </div>

         <!-- Request Course Modal -->
        <div class="modal fade" id="requestCourseModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">
                        <div class="card-header show-header">
                            <h3 class="card-title">Request Course</h3>
                            <button type="button" class="close" data-dismiss="modal" (click)="Formreset()">&times;</button>
                        </div>
                        <div class="card-body">
                            <form (ngSubmit)="onSubmitRequestCourse()" [formGroup]="requestcourse">
                                <div class="form-group row">
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Student Name</label>
                                        <input type="text" class="form-control" formControlName="student_name"
                                            />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Phone No</label>
                                        <input type="text" class="form-control" formControlName="phone_no"
                                             />
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="form-label">Course/Grade</label>
                                        <input type="text" class="form-control" formControlName="grade"
                                             />
                                    </div>
                                    <div class="form-group col-md-8">
                                        <label class="form-label">Institution</label>
                                        <input type="text" class="form-control" formControlName="college_name"
                                             />
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="form-label">District</label>
                                        <input type="text" class="form-control" formControlName="district"
                                            />
                                    </div>
                                    <div class="form-group col-md-8">
                                        <label class="form-label">Request Topic</label>
                                        <span class="required">*</span>
                                        <input type="text" class="form-control" formControlName="requestedCourse"
                                            placeholder="Please Enter Requested Topic" />
                                        <div *ngIf="requestcourse.get('requestedCourse')?.touched && requestcourse.get('requestedCourse')?.hasError('required')"
                                            class="invalid-feedback">
                                            Request Topic is required.
                                        </div>
                                    </div>
                                </div>
                                <button type="submit" class="btn btn-primary mt-4" [disabled]="requestcourse.invalid">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Request Group Course Modal -->
        <div class="modal fade" id="requestGroupCourseModal">
            <div class="modal-dialog modal-xl modal-dialog-centered">
                <div class="modal-content">
                    <div class="card">
                        <div class="card-header show-header">
                            <h3 class="card-title">Request Group Course</h3>
                            <button type="button" class="close" data-dismiss="modal"
                                (click)="Formreset()">&times;</button>
                        </div>
                        <div class="card-body">
                            <form (ngSubmit)="onSubmitGroupRequestCourse()" [formGroup]="grequestcourse">
                                <div class="form-group row">
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Student Name</label>
                                        <input type="text" class="form-control" formControlName="student_name"
                                             />
                                    </div>
                                    <div class="form-group col-md-6">
                                        <label class="form-label">Phone No</label>
                                        <input type="text" class="form-control" formControlName="phone_no"
                                             />
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="form-label">Course/Grade</label>
                                        <input type="text" class="form-control" formControlName="grade"
                                             />
                                    </div>
                                    <div class="form-group col-md-8">
                                        <label class="form-label">Institution</label>
                                        <input type="text" class="form-control" formControlName="college_name"
                                             />
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="form-label">District</label>
                                        <input type="text" class="form-control" formControlName="district"
                                             />
                                    </div>
                                    <div class="form-group col-md-8">
                                        <label class="form-label">Request Topic</label>
                                        <span class="required">*</span>
                                        <input type="text" class="form-control" formControlName="requestedCourse"
                                            placeholder="Please Enter Requested Topic" />
                                        <div *ngIf="grequestcourse.get('requestedCourse')?.touched && grequestcourse.get('requestedCourse')?.hasError('required')"
                                            class="invalid-feedback">
                                            Request Topic is required.
                                        </div>
                                    </div>
                                    <div class="form-group col-md-4">
                                        <label class="form-label">No of Students</label>
                                        <span class="required">*</span>
                                        <input type="number" class="form-control" formControlName="studentcount"
                                               placeholder="Please Enter Number of Students"
                                               (change)="onStudentCountChange($event)" [min]="2" [max]="30" />
                                        <div *ngIf="grequestcourse.get('studentcount')?.touched && grequestcourse.get('studentcount')?.hasError('required')"
                                             class="invalid-feedback">
                                            No Of Student Count is required.
                                        </div>
                                        <div *ngIf="grequestcourse.get('studentcount')?.touched && grequestcourse.get('studentcount')?.hasError('min')"
                                             class="invalid-feedback">
                                            Please enter a value greater than or equal to 2.
                                        </div>
                                        <div *ngIf="grequestcourse.get('studentcount')?.touched && grequestcourse.get('studentcount')?.hasError('max')"
                                             class="invalid-feedback">
                                            Please enter a value less than or equal to 30.
                                        </div>
                                    </div>

                                </div>

                                <!-- Table for student entries -->
                                <div *ngIf="studentcountValue >= 2 && studentcountValue <= 30">
                                    <table class="table table-bordered mt-3">
                                        <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Student Name</th>
                                                <th>Phone No</th>
                                                <th>Email-id</th>
                                            </tr>
                                        </thead>
                                        <tbody> 
                                            <tr *ngFor="let student of studentsFormGroups; let i = index;"
                                                [formGroup]="student">
                                                <td>{{ i+1 }}</td>
                                                <td>
                                                    <input type="text" class="form-control"
                                                        formControlName="studentName"
                                                        placeholder="Enter Student Name" />
                                                    <div *ngIf="student.get('studentName')?.touched && student.get('studentName')?.hasError('required')"
                                                        class="invalid-feedback">
                                                        Student Name is required.
                                                    </div>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" formControlName="phoneNo"
                                                        placeholder="Enter Phone Number" />
                                                    <div *ngIf="student.get('phoneNo')?.touched && student.get('phoneNo')?.hasError('required')"
                                                        class="invalid-feedback">
                                                        Phone Number must be exactly 10 digits.
                                                    </div>
                                                </td>
                                                <td>
                                                    <input type="text" class="form-control" formControlName="email"
                                                        placeholder="Enter Email-id" />
                                                        <div *ngIf="student.get('email')?.touched && student.get('email')?.hasError('required')"
                                                        class="invalid-feedback">
                                                       Email-id is required.
                                                   </div>
                                                   <div *ngIf="student.get('email')?.touched && student.get('email')?.hasError('email')"
                                                        class="invalid-feedback">
                                                       Please enter a valid email address.
                                                   </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>

                                <button type="submit" class="btn btn-primary mt-4"
                                    [disabled]="grequestcourse.invalid">Submit</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-lg-12">
                <app-student-course></app-student-course>
            </div>
        </div>
    </div>
</section>